/**
 * Organization/Project Switcher Component
 * Read-only display of the current organization and project
 * Users switch via the MANAGEMENT menu (Organizations/Projects pages)
 */

import { html, attr, type Renderable } from '@tempots/dom'
import { Icon } from '@tempots/beatui'
import { Workspace } from '@/state/workspace'

// ============================================================================
// Organization Switcher Component
// ============================================================================

export function OrgProjectDisplayer(): Renderable {
  const orgName = Workspace.organization.$.name
  const projName = Workspace.project.$.name
  const isPersonal = Workspace.organization.$.isPersonal
  const orgIcon = isPersonal.map((p): string =>
    p ? 'mdi:account-circle' : 'mdi:office-building'
  )

  return html.div(
    attr.class('pl-1 pr-3 py-2'),
    html.div(
      attr.class('flex items-center gap-3'),
      Icon(
        { icon: orgIcon },
        attr.class('w-5 h-5 text-gray-500 flex-shrink-0')
      ),
      html.div(
        attr.class('flex-1 min-w-0'),
        html.div(
          attr.class('text-sm font-medium text-gray-900 truncate'),
          orgName
        ),
        html.div(attr.class('text-xs text-gray-500 truncate'), projName)
      )
    )
  )
}
